import { render, staticRenderFns } from "./proList.vue?vue&type=template&id=1e210586&scoped=true&"
import script from "./proList.vue?vue&type=script&lang=js&"
export * from "./proList.vue?vue&type=script&lang=js&"
import style0 from "./proList.vue?vue&type=style&index=0&id=1e210586&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e210586",
  null
  
)

export default component.exports